/*
  PEFSA — cart shipping estimator: shows the store's own route name instead of
  Shopify's generic local delivery label. Display only: checkout and the order
  keep the name Shopify assigns. Official cart.js stays untouched.
*/
(function () {
  var LABELS = { 'local delivery': 'Ruta PEFSA', 'entrega local': 'Ruta PEFSA' };

  function relabel() {
    document.querySelectorAll('shipping-calculator-modal .presentment-name').forEach(function (el) {
      var next = LABELS[el.textContent.trim().toLowerCase()];
      if (next) el.textContent = next;
    });
  }

  new MutationObserver(relabel).observe(document.documentElement, { childList: true, subtree: true });
})();
